import { Map as ImmutableMap, List, Record } from 'immutable';

export const mkRootUiData = Record({
  type: 'UNKNOWN',
  id: '0',
  visible: true,
  allowNesting: true,
  props: ImmutableMap(),
});

export const mkRootUiStore = Record({
  activeModals: List(),
  queuedModals: List(),
});
